import Home from "./home";
import Details from "./detaljer";
import Kleskode from "./kleskode";
import Underholdning from "./underholdning";
import Onskeliste from "./onskeliste";
import PraktiskInformasjon from "./praktiskinfo";

export default function MainPage() {

  return (
    <div>
        <section id="home">
        <Home />
        </section>

        <section id="details">
        <Details />
        </section>

        <section id="kleskode">
        <Kleskode />
        </section>

        <section id="onskeliste">
        <Onskeliste />
        </section>

        <section id="underholdning">
        <Underholdning />
        </section>
        
        <section id="praktiskinfo">
          <PraktiskInformasjon />
        </section>
    </div>
  );
}
